/* FAQ accordion for the two course pages.

   The same `items` array also feeds the FAQPage JSON-LD in src/seo/head.mjs
   (read straight out of the locale files), so the questions and answers a
   visitor sees are exactly the ones Google is told about. */

import React, { useState } from 'react';
import { BRAND, INK, BODY, serif, sans } from './blocks';

const Item = ({ item, extra, defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div
      style={{
        borderRadius: '16px',
        border: '1px solid rgba(144,81,15,0.16)',
        background: '#fff',
        overflow: 'hidden',
      }}
    >
      <h3 style={{ margin: 0 }}>
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '16px',
            padding: '20px 22px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            textAlign: 'left',
            fontFamily: serif,
            fontSize: '19px',
            fontWeight: 600,
            color: INK,
            lineHeight: 1.35,
          }}
        >
          {item.q}
          <span
            aria-hidden="true"
            style={{
              flexShrink: 0,
              color: BRAND,
              fontSize: '20px',
              lineHeight: 1,
              transform: open ? 'rotate(45deg)' : 'none',
              transition: 'transform 0.25s ease',
            }}
          >
            +
          </span>
        </button>
      </h3>

      {open && (
        <div style={{ padding: '0 22px 22px' }}>
          <p
            style={{
              fontFamily: sans,
              fontSize: '16px',
              lineHeight: 1.8,
              color: BODY,
              margin: 0,
            }}
          >
            {item.a}
          </p>
          {extra}
        </div>
      )}
    </div>
  );
};

/**
 * @param {Array<{q: string, a: string}>} items
 * @param {(item, index) => React.ReactNode} renderExtra
 *        optional extra node under an answer (used for the link to the other course)
 */
const Faq = ({ items, renderExtra }) => (
  <div style={{ display: 'grid', gap: '12px' }}>
    {items.map((item, i) => (
      <Item
        key={i}
        item={item}
        defaultOpen={i === 0}
        extra={renderExtra ? renderExtra(item, i) : null}
      />
    ))}
  </div>
);

export default Faq;
